// extracted by mini-css-extract-plugin
module.exports = {"input":"TextArea-module--input--3e31d","error":"TextArea-module--error--2STAh","label":"TextArea-module--label--Jz9R7","required":"TextArea-module--required--8yawy"};